import { useTranslation } from 'react-i18next';

import { Card } from '../../components/Card';

export function LoadingState() {
  const { t } = useTranslation();
  return (
    <Card>
      <div className="spinner-wrap" role="status" aria-live="polite">
        <div className="spinner" aria-hidden="true" />
        <span>{t('loading')}</span>
      </div>
    </Card>
  );
}
